// Non-sensitive localStorage flag marking "this browser has logged in before".
// RootGate uses it to decide what to render while the silent token refresh is
// in flight at `/`: no hint → render the landing page immediately (guests are
// the common case at the root); hint set → show a spinner so returning users
// don't see a landing flash before their dashboard.
const KEY = "adam:returning";

export function hasSessionHint(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setSessionHint(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // Storage unavailable (private mode) — worst case is a brief landing flash.
  }
}

export function clearSessionHint(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Storage unavailable — nothing to clear.
  }
}
